import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { AuthService } from 'src/app/services/auth.service';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  constructor(private authService: AuthService, private dialog: MatDialog) { }

  ngOnInit() {
  }

  onResetPassword(form: NgForm) {
    const mobile = localStorage.getItem('resetMobile');

    const data = new FormData;
    data.append('verificationCode', form.value.verificationCode);
    data.append('password', form.value.password);
    data.append('mobile', mobile);

    this.authService.resetPassword(data);
  }

  onLogin() {
    this.dialog.closeAll();
    this.dialog.open(LoginComponent);
  }
}
